import { getGroupRatingApi } from "./get-group-rating"

import type {
  UpdateRankPermissionThresholdsRequest,
  UpdateRankPermissionThresholdsResponse,
  UpdateRankRequest,
  UpdateRankResponse
} from "./types"

export const updateGroupRatingApi = getGroupRatingApi.injectEndpoints({
  endpoints: builder => ({
    updateRank: builder.mutation<UpdateRankResponse, UpdateRankRequest>({
      query: ({ chatId, rankUpdate }) => ({
        url: `/api/v1/group/rating/ranks?chat_id=${chatId}&rank_id=${rankUpdate.rank_id}`,
        method: "PATCH",
        body: rankUpdate
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["RankUpdate"])
    }),

    updateRankPermissionThresholds: builder.mutation<
      UpdateRankPermissionThresholdsResponse,
      UpdateRankPermissionThresholdsRequest
    >({
      query: ({ chatId, thresholds }) => ({
        url: `/api/v1/group/rating/rank/permission/thresholds?chat_id=${chatId}`,
        method: "PATCH",
        body: { thresholds }
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["PermissionUpdate"])
    })
  })
})

export const { useUpdateRankMutation, useUpdateRankPermissionThresholdsMutation } = updateGroupRatingApi
